import DeliveryOptionsContainer from './deliveryOptions/DeliveryOptions.container';

const DeliveryOptions = () => {
  return <DeliveryOptionsContainer />;
};

export default DeliveryOptions;
